import veProgress from 'vue-ellipse-progress'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(veProgress)
})
